// Mirror of backend SCHOOL_SEAT_PLAN in easyreports-backend/src/templates/creditPacks.js.
// Values MUST match - backend is the source of truth for quota enforcement.
export const SCHOOL_SEAT_PLAN = {
  reportsPerSeat: 120,
  aiCreditsPerSeat: 200,
};

// Default credits granted to a brand-new user. Matches DEFAULT_CREDITS in
// easyreports-backend/src/services/userSubscriptionService.js.
export const DEFAULT_USER_CREDITS = 20;
